import { render, staticRenderFns } from "./BuyDiscount.vue?vue&type=template&id=006cda72"
import script from "./BuyDiscount.vue?vue&type=script&lang=ts"
export * from "./BuyDiscount.vue?vue&type=script&lang=ts"
import style0 from "./BuyDiscount.vue?vue&type=style&index=0&id=006cda72&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports